import * as React from 'react';

import DashboardIcon from '@mui/icons-material/Dashboard';

import { MANTY_ORANGE, usePrimaryColor } from 'styles/theme';
import { DashboardSVG } from './DashboardIcon';
import { Tile, Props } from './Tile';

export const DashboardTile = (props: Props): React.ReactElement => (
    <Tile icon={<DashboardIcon style={{ color: MANTY_ORANGE }} />} {...props}>
        <DashboardSVG
            primaryColor={usePrimaryColor()}
            className="dashboard-tile-image"
        />
    </Tile>
);
